export const shrinkStringInMiddle = (str: string, maxLength: number) => {
  if (str.length <= maxLength) return str
  const half = Math.floor((maxLength - 3) / 2)
  return str.slice(0, half) + '...' + str.slice(-half)
}
